import axios from "axios";
import APIURL from "../../Main/apiurl";

const create_feature_lock = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-feature-lock`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_feature_lock = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-feature-lock`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_feature_locks = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-all-feature-locks`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_user_features = async () => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-user-features`, {}, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const unlock_feature = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/unlock-feature`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_feature_status = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-feature-status`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_user_plan = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-user-plan`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_feature_lock,
  update_feature_lock,
  get_all_feature_locks,
  get_user_features,
  unlock_feature,
  get_feature_status,
  get_user_plan
};